<template>
    <div>
        <router-link to="/">トップページ</router-link>
        <router-link to="/intro">自己紹介</router-link>
    </div>
</template>

<script>
export default {
    name: 'PageNavi'
}
</script>



// WEBPACK FOOTER //
// src/components/PageNavi.vue